// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-FormBuilder-SuggestionsMessage-module__suggestionsMessage";
export { _1 as "suggestionsMessage" }
